// supabaseClient.js
import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://bsnmwcoybhorbvktfixc.supabase.co'  // ← ここを自分のURLに置き換え
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJzbm13Y295YmhvcmJ2a3RmaXhjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQ2MjgxNTQsImV4cCI6MjA2MDIwNDE1NH0.3diFlPxQkDItZbLfZ8GHWUIl3t0IjCnv2GUyhYvr2b8'                // ← Supabaseのanonキーを使用
export const supabase = createClient(supabaseUrl, supabaseKey)
